import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=0033e48f&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=js"
export * from "./Form2.vue?vue&type=script&lang=js"
import style0 from "./Form2.vue?vue&type=style&index=0&id=0033e48f&prod&scoped=true&lang=css"
import style1 from "./Form2.vue?vue&type=style&index=1&id=0033e48f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0033e48f",
  null
  
)

export default component.exports